module.exports = __webpack_public_path__ + "img/derivUpOff.39606912.svg";